import { createContext, use, useEffect, useState } from 'react';
import { useOfflineSync } from '@/lib/hooks/use-offline-sync';
import { sortPassages } from './passage-data-service';
import { DBCollection } from '@/lib/utils/constants-shared';
import { AppDataContext } from '@/lib/app-data-hydration';
import { DBContext } from '@/lib/context';
import { DataCacheService } from '@/lib/utils/data-cache-service';

type ItemType = Passage;
const collection = DBCollection.passages;

export const PassageDataContext = createContext<DataContext<ItemType>>(undefined);

export function PassageDataProvider({ children }) {
    const db = use(DBContext);
    const {data: allData} = use(AppDataContext);
    const {markForSync, resolveSync} = useOfflineSync();
    const [data, setData] = useState<ItemData<ItemType>>();
    const service = new DataCacheService<ItemData<ItemType>>(db, collection, markForSync, resolveSync, data, setData, sortPassages, []);

    useEffect(() => {
        service.setNewItems(allData?.passages);
    }, [allData?.passages]);

    return <PassageDataContext value={{
        add: item => service.add(item),
        data,
        get: id => service.get(id),
        remove: id => service.remove(id),
        update: partial => service.update(partial),
        updateAll: items => service.updateAll(items)
    }}>
        {children}
    </PassageDataContext>;
}